import orderBy from 'lodash/orderBy';

import { PromotionType } from './types';

export const orderPromotionsByDisplayPriorityOrEndDate = (
  promotions: PromotionType[],
) => orderBy(promotions, ['DisplayPriority', 'EndDate'], ['asc', 'asc']);
